import type { App } from 'utils/app/types';
import type { Core } from 'chessboard/core/config/types';

/**
 * Returns a function that checks multiple conditions are true
 */
export function pipeConditions(...conditions: Function[]) {
  return function checkMultipleConditions(event: App.Event, context: Core.Context): boolean {
    return conditions.every((condition) => condition(event, context));
  };
}
